export default __webpack_public_path__ + "static/media/hero.924eb554.png";